<template>
  <Table :rows="rows" :columns="columns" columnID="idx" />
</template>

<script>
import Table from "../../shared/components/Table.vue";
export default {
  components: { Table },
  props: {
    rows: Array
  },
  data() {
    return {
      columns: [
        {
          key: "tabla",
          label: "Tabla.",
          width: 60,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "codigo",
          label: "Cód.",
          width: 70,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "fecha",
          label: "Fecha.",
          width: 60,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "servicio",
          width: 120
        },
        {
          key: "conductor",
          width: 120
        },
        {
          key: "usuarioCreador",
          label: "U. C.",
          width: 100
        },
        {
          key: "usuarioModificador",
          label: "U. M.",
          width: 100
        }
      ]
    };
  }
};
</script>

<style></style>
